"use strict";
'use client';
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFinEvent = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var FinProvider_1 = require("../components/FinProvider");
function useFinEvent() {
    var _a = (0, react_1.useContext)(FinProvider_1.FinContext), next = _a.next, register = _a.register;
    var triggerEvent = function (type, params) {
        return next(tslib_1.__assign({ type: type }, params));
    };
    var registerHandler = function (type, handler) {
        return register({
            type: type,
            handler: handler,
        });
    };
    return [triggerEvent, registerHandler];
}
exports.useFinEvent = useFinEvent;
//# sourceMappingURL=use-fin-event.js.map